module.exports = __webpack_public_path__ + "static/a-thousand-pardons-4b7bb1320754808921cbc01f15f36446.jpg";